export default __webpack_public_path__ + "f4cc3dbf6412c4241fc44a17ce96037f.png";